export default "__VITE_ASSET__bB6ydZ4r__"